import type { FC } from "react";

import type { UserAssignmentDetailFragment } from "api/generated";
import { AssignmentPrompt } from "components/AssignmentPrompt";
import { LastYearResultsBanner } from "components/LastYearResultsBanner/LastYearResultsBanner";
import { VideoAccordion } from "features/Tutoring/shared/VideoAccordion";

interface Props {
  data: UserAssignmentDetailFragment;
  userAssignmentId: string;
  videoIds: string[];
  videoTips: Array<{ videoId: string; previewImage?: string | null | undefined }>;
  activeAccordion: string | string[] | undefined | null;
  toggleAccordion: (state: boolean) => void;
}

export const TutoringHeader: FC<Props> = ({
  data,
  userAssignmentId,
  videoIds,
  videoTips,
  activeAccordion,
  toggleAccordion,
}) => (
  <div>
    {typeof data.assignment?.successRate === "number" && <LastYearResultsBanner level={data.assignment.successRate} />}

    <AssignmentPrompt assignment={data.assignment?.assignment} />
    <VideoAccordion
      videoIds={videoIds}
      videoTips={videoTips}
      transcriptCs={data.assignment?.assignment?.transcriptCs}
      transcriptEn={data.assignment?.assignment?.transcriptEn}
      activeAccordion={activeAccordion}
      toggleAccordion={toggleAccordion}
    />
  </div>
);
